const resources = {
  // RESPONSE TIME
  RESPONSE_TIME_CREATE_PREFERRED:
    'You are in a Preferred Support Plan. For this plan, first response time is targeted to be 1 business hour or less, depending on priority, or 1 hour for critical production outages.',
  RESPONSE_TIME_UPDATE_PREFERRED:
    'You are in a Preferred Support Plan. For this plan, subsequent response times are targeted to be 4 business hours for standard issues and ongoing for critical production outages.',

  RESPONSE_TIME_CREATE_30MIN:
    'You are in a 30-min Enterprise Support Plan. For this plan, first response time is targeted to be 30 min or less, depending on priority.',
  RESPONSE_TIME_UPDATE_30MIN:
    'You are in a 30-min Enterprise Support Plan. For this plan, subsequent response times are targeted to be 8 business hours for standard issues and ongoing for critical production outages.',

  RESPONSE_TIME_CREATE_ENTERPRISE:
    'You are in an Enterprise Support Plan. For this plan, first response time is 3 business hours for standard issues or 1 hour for critical production outages.',
  RESPONSE_TIME_UPDATE_ENTERPRISE:
    'You are in an Enterprise Support Plan. For this plan, subsequent response times are 8 business hours for standard issues and ongoing for critical production outages.',

  RESPONSE_TIME_CREATE_STANDARD:
    'You are in a Standard Support Plan. For this plan, the first response time is 2 business days or less depending on priority. You can learn more about support plans <a target="_blank" href="https://auth0.com/docs/support">here</a>.',
  RESPONSE_TIME_UPDATE_STANDARD:
    'You are in a Standard Support Plan. For this plan, subsequent response times are 16 business hours or less depending on priority. You can learn more about support plans <a target="_blank" href="https://auth0.com/docs/support">here</a>.',

  RESPONSE_TIME_CREATE_FREE: '',
  RESPONSE_TIME_UPDATE_FREE:
    'As a Free Plan customer you can respond to support tickets created during your trial. Ongoing support is provided through <a target="_blank" href="https://community.auth0.com">Auth0 Community</a> which is staffed by the Auth0 team members and enthusiasts, you can post questions and search for answers there. For more information check out our <a target="_blank" href="https://auth0.com/docs/support">support policies</a>.',

  RESPONSE_TIME_CREATE_TRIAL:
    'Auth0 customers receive Standard Support during the trial period. For this plan, the first response time is 2 business days or less depending on priority. You can learn more about support plans <a target="_blank" href="https://auth0.com/docs/support">here</a>.',
  RESPONSE_TIME_UPDATE_TRIAL:
    'Auth0 customers receive Standard Support during the trial period. For this plan, subsequent response times are 16 business hours or less depending on priority. You can learn more about support plans <a target="_blank" href="https://auth0.com/docs/support">here</a>.',

  RESPONSE_TIME_GENERIC:
    'Response times will vary based on your <a target="_blank" href="https://auth0.com/docs/support">support plan</a>.',

  RESPONSE_TIME_FORUM:
    'Please note we have a <a target="_blank" href="https://community.auth0.com">community forum</a> where you can search to see if your question has already been answered or post your question to a wider audience which may help you get an answer sooner.',

  // TOOLTIPS
  CONTACT_SALES_TOOLTIP:
    'Talk to sales about upgrading your account and other features that Auth0 offers',
  CURRENT_TOTAL_USERS_TOOLTIP:
    'Any user that authenticated with any connection or identity provider.',
  EMPLOYEE_USERS_TOOLTIP:
    'An internal employee of your company that authenticated with any connection or identity provider.',
  REGULAR_ACTIVE_USERS_TOOLTIP:
    'A user that has authenticated with username/password, passwordless connections or any social provider per calendar month, counted per application.',
  ENTERPRISE_ACTIVE_USERS_TOOLTIP:
    'A user that has authenticated using an enterprise connection like SAML, Active Directory or LDAP among others per calendar month, counted per application.',
  REGULAR_ACTIVE_USERS_TOOLTIP30D:
    'A user that has authenticated with username/password, passwordless connections or any social provider in the last 30 days, counted per application.',
  ENTERPRISE_ACTIVE_USERS_TOOLTIP30D:
    'A user that has authenticated using an enterprise connection like SAML, Active Directory or LDAP among others in the last 30 days, counted per application.',
  ACTIVE_USERS_TOOLTIP:
    'Users that have authenticated using each connection type, counted per month, per tenant.',
  TOTAL_USERS_TOOLTIP:
    'Users that exist on each tenant on a particular month, regardless of the number of logins.',

  // REPORTS
  ACTIVE_USERS_PER_MONTH: [
    'This table shows monthly ',
    'active users',
    ' by user type for the past 12 months of the subscription. '
  ],
  ACTIVE_USERS_PER_MONTH_AND_SERVICE: [
    'This table shows monthly ',
    'active users',
    ' by user type for each tenant for the past 12 months of the subscription. '
  ],
  EMPLOYEE_USERS_PER_MONTH:
    'This table shows monthly employee users for the past 12 months of the subscription. ',
  EMPLOYEE_USERS_PER_MONTH_AND_SERVICE:
    'This table shows monthly employee users for each tenant for the past 12 months of the subscription. ',
  ACTIVE_USERS_LAST_30D_AND_SERVICE:
    'This table shows active users by user type for each tenant for the <b>last 30 days</b> of the subscription. ',
  ACTIVE_USERS_LAST_30D_AND_CLIENT:
    'This tables shows active users by user type for each application for the <b>last 30 days</b> of the subscription. ',
  TOTAL_USERS_PER_SERVICE_30D:
    'This table shows total active users for each tenant for the <b>last 30 days</b> of the subscription. ',
  TOTAL_USERS_PER_SERVICE:
    'This table shows total existing users for each tenant of the subscription.  ',
  TOTAL_USERS_PER_MONTH_AND_SERVICE: [
    'This table shows monthly ',
    'total users',
    ' for each tenant of the subscription.  '
  ]
};

export default resources;
